import { ServiceModel, isStandaloneFromService } from '@water-web/repository';

export const isStandaloneService = (service: ServiceModel): boolean => {
  return isStandaloneFromService(service.getDataValues());
};
